
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-487fc12e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CustomerPurchaseOrder.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerPurchaseOrder.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-487fc12e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerPurchaseOrder.vue"),
  /* scopeId */
  "data-v-487fc12e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/platformManagement/CustomerPurchaseOrder.vue
// module id = 1541
// module chunks = 3